import { graphql } from "react-relay";

export const RemoveProfileMutation = graphql`
  mutation RemoveProfileMutation($name: String!, $scope: String!) {
    removeProfile(name: $name, scope: $scope) @deleteRecord
  }
`;
